import Link from 'next/link';
import Score from "./score";
import {useTranslation} from "next-i18next";

export type CompareData = {
    id : string
    title : string
    link : string
    score : number
    ratio : number
    count : number
};

type Data = {
    compare : CompareData
};

/**
 *
 * @param product
 * @constructor
 */
export default function WithAndWithoutItem ({ compare } : Data) {
    // init
    const { t } = useTranslation();

    // render
    return (
        <>
            <div className="col-12 col-sm-12 col-md-5 p-1">
                <div className="container p-0 m-0">
                    <div className="row">
                        <Link href={compare.link} className="p-0 text-decoration-none text-start text-md-center col-2 col-sm-1 col-md-12 mb-md-3">
                            <Score value={compare.score} size={"big"} />
                        </Link>
                        <div className="col-10 col-sm-11 col-md-12 ps-xs-2 ps-sm-4 ps-md-0">
                            <Link href={compare.link} className={'text-decoration-none'}>
                                <h2 className="h5 text-start text-md-center mb-2 text-truncate">{compare.title}</h2>
                            </Link>
                            <div className="row justify-content-md-center m-0">
                                <p className={'h5 p-0 m-0 mb-1 text-md-center fw-bold'}>{compare.ratio}%</p>
                                <p className={'fst-italic p-0 m-0 small text-muted text-md-center'}>{t('based.on.products', {ns: 'glossary', count: compare.count})}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}